import React from "react";

export default function NumberIcon({ordinal=99}) {
  return <div className="absolute top-8 left-0">
    <span className={
      "bg-gray-400 text-white rounded-full px-3 py-1 text-xl opacity-50 z-20"
    }>{ordinal}</span>
  </div>
}
